/*
 * Arcana Age Gate — entry verification interactions.
 *
 * The gate is shown pre-paint by the inline guard in layout/theme.liquid
 * (which adds `arcana-age-pending` to <html> when no verified cookie is set).
 * This script only wires the interactions and removes the guard once a
 * visitor verifies. It fails closed: if it never runs, content stays hidden.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  // Nothing to do if the visitor is already verified (no pending guard set).
  if (!html.classList.contains('arcana-age-pending')) return;

  var gate = document.getElementById('arcana-age-gate');
  if (!gate) return;

  var modal = gate.querySelector('.age-gate__modal');
  var choice = gate.querySelector('.age-gate__choice');
  var decline = gate.querySelector('.age-gate__decline');
  var minAge = parseInt(gate.getAttribute('data-min-age'), 10) || 18;
  var rememberDays = parseInt(gate.getAttribute('data-remember-days'), 10);
  if (isNaN(rememberDays)) rememberDays = 30;

  document.body.classList.add('age-gate-active');

  /* The Private Treaty image normally loads lazily for performance. While the
     gate is visible it forms part of the blurred backdrop, so request it now
     without giving it priority over the homepage hero. */
  var privateTreatyImage = document.querySelector(
    '.arcana-home-featured .arcana-home-featured__private-media img'
  );
  if (privateTreatyImage) {
    privateTreatyImage.loading = 'eager';
    privateTreatyImage.fetchPriority = 'low';
  }

  function setVerifiedCookie() {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    var maxAge = rememberDays > 0 ? '; Max-Age=' + rememberDays * 86400 : '';
    document.cookie = 'arcana_age_verified=1; path=/' + maxAge + '; SameSite=Lax' + secure;
  }

  function reveal() {
    setVerifiedCookie();
    html.classList.remove('arcana-age-pending');
    document.body.classList.remove('age-gate-active');
    gate.setAttribute('hidden', 'hidden');
  }

  function showDecline() {
    if (choice) choice.hidden = true;
    if (decline) {
      decline.hidden = false;
      var focusTarget = decline.querySelector('a, button, [tabindex]') || decline;
      focusTarget.setAttribute('tabindex', focusTarget.getAttribute('tabindex') || '-1');
      focusTarget.focus();
    }
  }

  // --- Focus management & trap -------------------------------------------
  function focusable() {
    return Array.prototype.filter.call(
      gate.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return el.offsetParent !== null; // visible only
      }
    );
  }

  function trapTab(e) {
    if (e.key !== 'Tab') return;
    var items = focusable();
    if (!items.length) {
      e.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  gate.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      // An age gate can never be escaped to enter — Esc triggers decline.
      e.preventDefault();
      showDecline();
      return;
    }
    trapTab(e);
  });

  // Move focus into the modal on open.
  var initialFocus = gate.querySelector('.age-gate__heading') || modal;
  if (initialFocus) {
    initialFocus.setAttribute('tabindex', initialFocus.getAttribute('tabindex') || '-1');
    initialFocus.focus();
  }

  // --- Confirm-button mode ------------------------------------------------
  var confirmBtn = document.getElementById('age-gate-confirm');
  if (confirmBtn) confirmBtn.addEventListener('click', reveal);

  var denyBtn = document.getElementById('age-gate-deny');
  if (denyBtn) denyBtn.addEventListener('click', showDecline);

  // --- Date-of-birth mode -------------------------------------------------
  var dobForm = gate.querySelector('.age-gate__dob');
  if (dobForm) {
    var daySel = dobForm.querySelector('[data-dob="day"]');
    var monthSel = dobForm.querySelector('[data-dob="month"]');
    var yearSel = dobForm.querySelector('[data-dob="year"]');
    var errorEl = dobForm.querySelector('.age-gate__error');

    var now = new Date();
    var currentYear = now.getFullYear();
    if (yearSel) {
      for (var y = currentYear; y >= currentYear - 120; y--) {
        var opt = document.createElement('option');
        opt.value = String(y);
        opt.textContent = String(y);
        yearSel.appendChild(opt);
      }
    }

    function computeAge(year, month, day) {
      var age = currentYear - year;
      var m = now.getMonth() + 1 - month;
      if (m < 0 || (m === 0 && now.getDate() < day)) age--;
      return age;
    }

    dobForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.textContent = '';
      var day = parseInt(daySel && daySel.value, 10);
      var month = parseInt(monthSel && monthSel.value, 10);
      var year = parseInt(yearSel && yearSel.value, 10);
      if (!day || !month || !year) {
        if (errorEl) errorEl.textContent = 'Please enter your full date of birth.';
        return;
      }
      // Reject impossible dates (e.g. 31 Feb) via round-trip.
      var probe = new Date(year, month - 1, day);
      if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) {
        if (errorEl) errorEl.textContent = 'Please enter a valid date.';
        return;
      }
      if (computeAge(year, month, day) >= minAge) {
        reveal();
      } else {
        showDecline();
      }
    });
  }
})();
